import { render, staticRenderFns } from "./StepGuide.vue?vue&type=template&id=12761aec&scoped=true&"
import script from "./StepGuide.vue?vue&type=script&lang=js&"
export * from "./StepGuide.vue?vue&type=script&lang=js&"
import style0 from "./StepGuide.vue?vue&type=style&index=0&id=12761aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12761aec",
  null
  
)

export default component.exports